import React from 'react';
import PropTypes from 'prop-types';
import { BulkSelectionConsumer, BulkSelectionContextPropTypes } from '../BulkSelection';
export var TableToolbarContainer = function TableToolbarContainer(props) {
  return /*#__PURE__*/React.createElement(BulkSelectionConsumer, {
    consumerCompName: "Table.ToolbarContainer",
    providerCompName: "Table"
  }, props.children);
};
TableToolbarContainer.displayName = 'Table.ToolbarContainer';
TableToolbarContainer.propTypes = {
  children: PropTypes.any
};
/** Helper for PropTypes for components which consume the SelectionContext */

export var SelectionContextPropTypes = BulkSelectionContextPropTypes;